<script lang="ts" setup>
  import { loadSlim } from 'tsparticles-slim'
  import { ref } from 'vue'
  import { onMounted } from 'vue'
  import { useForm } from 'vee-validate'
  import * as yup from 'yup'
  import logo from '../../../assets/logo_new_res.png'
  import { useUserStore } from '@/store/user'
  import { useRouter } from 'vue-router'
  import { nasaParticle } from '@/assets/particles/nasa'

  const schema = yup.object({
    email: yup
      .string()
      .required('El correo es requerido')
      .email('Ingrese un correo válido'),
    password: yup
      .string()
      .required('La contraseña es requerida')
      .min(8, 'La contraseña debe tener al menos 8 caracteres'),
  })

  const { resetForm, errors } = useForm({ validationSchema: schema })
  const router = useRouter()

  const store = useUserStore()
  const email = ref('')
  const password = ref('')
  const isLoading = ref(false)
  const isSubmitted = ref(false)

  onMounted(() => {
    if (store.user !== null) {
      store.logout()
    }
  })

  const login = async () => {
    isSubmitted.value = true
    isLoading.value = true
    const response = await store.login(email.value, password.value)
    resetForm()
    isLoading.value = false
    if (response) {
      const redirectRoute = localStorage.getItem('redirect')
      if (redirectRoute && store.user?.idToken) {
        localStorage.removeItem('redirect')
        router.push(redirectRoute)
      } else {
        if (store.user?.idToken == '' && store.user.session) {
          localStorage.setItem('email', email.value)
          router.push('/update')
        } else {
          console.log('USER', store.user)
          router.push('/home')
        }
      }
    }
  }

  const particlesInit = async (engine: any) => {
    await loadSlim(engine)
  }

  const particlesLoaded = async (container: any) => {}
</script>
<template>
  <div class="container">
    <vue-particles
      id="tsparticles"
      :particlesInit="particlesInit"
      :particlesLoaded="particlesLoaded"
      :options="nasaParticle"
    />
    <Card class="login-card">
      <template #header>
        <img class="logo" height="42" :src="logo" alt="Autogestión" />
      </template>

      <template #title>
        <h2>Inicio de sesión</h2>
      </template>

      <template #subtitle> Bienvenido de regreso </template>

      <template #content class="padding-2">
        <form id="login-form" @submit.prevent="login">
          <label for="email" class="font-medium text-secondary-800"
            >Correo electrónico</label
          >
          <InputText v-model="email" type="email" id="email" />
          <span class="error-message" v-if="!email && isSubmitted">
            {{ errors.email }}
          </span>
          <br />

          <label for="password" class="font-medium text-secondary-700"
            >Contraseña</label
          >
          <Password
            v-model="password"
            type="password"
            id="password"
            :feedback="false"
            toggleMask
            :pt="{
              input: {
                class: 'input-fix',
              },
              panel: {
                class: 'hidden',
              },
            }"
          />
          <span class="error-message" v-if="!password && isSubmitted">
            {{ errors.password }}
          </span>
          <br />

          <Button type="submit" :class="isLoading ? 'p-disabled loading' : ''">
            <span v-if="isLoading">
              <i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
            </span>
            <span v-else>Iniciar sesión</span>
          </Button>
          <br />
          <a
            class="cursor-pointer font-medium text-primary-700 mb-2 hover:underline"
            @click="router.push('/forgotPassword/email')"
            >¿Has olvidado tu contraseña? Recuperala aqui.</a
          >
          <!-- <a href="#">Activar usuario.</a> -->
        </form>
      </template>
    </Card>
  </div>
</template>
<style scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    height: auto;
    /* Beautiful gradient background using the page's palette: blue and light tones */
    /* background: linear-gradient(135deg, #DBE7FF 0%, #71a7ff 60%, #f8f9fa 100%); */
  }

  .login-card {
    width: 25em;
    min-height: 4rem;
    padding: 2rem;
    z-index: 9;
  }

  .logo {
    width: 100%;
    object-fit: contain;
    height: 80px;
  }

  #login-form {
    display: flex;
    flex-flow: column wrap;
    text-align: left;
  }

  Button {
    display: block;
  }

  label {
    padding-bottom: 5px;
  }

  .error-message {
    padding-top: 5px;
    color: rgb(234, 68, 68);
    font-size: 12px;
  }

  @media (max-width: 539px) {
    .login-card {
      width: 22em;
      padding-inline: 0px;
    }
  }

  @media (max-width: 370px) {
    .login-card {
      width: 18em;
    }
  }
</style>
